// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'babel-polyfill'
import $ from 'jquery'
import config from './lib/config.js'
import httpRequest from './utils/httpRequest' // api: https://github.com/axios/axios
import VueCookie from 'vue-cookie'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
  Dialog,
  Button,
  CheckboxGroup,
  Checkbox,
  Form,
  FormItem,
  Input,
  DatePicker
} from 'element-ui';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(ElementUI);
Vue.use(config);
Vue.use(VueCookie);
Vue.use(Button);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(VideoPlayer);
Vue.use(iView);
Vue.config.productionTip = false;
Vue.prototype.$http = httpRequest; // ajax请求方法
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  created() {
    let token = this.$cookie.get('xjaf-token');
    var user = JSON.parse(this.$cookie.get('xjaf-user'));
    if (token && user) {
      this.$store.commit('getUser', user);
      this.$store.state.isLogin = true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js